<div class="snackbar" [class]="'snackbar--' + data.type">
    <span
        class="snackbar__icon"
        [class]="data.type === 'success' ? 'icon-check' : 'icon-close'"
    ></span>
    <span class="snackbar__message">{{ data.message }}</span>
    <button
        mat-icon-button
        class="close-btn"
        (click)="snackBarRef.dismiss()"
        aria-label="Close"
    >
        <span class="icon-close"></span>
    </button>
</div>
